import { useQuery } from '@tanstack/react-query';
import { auditService } from '@/services/audit/audit.service';

export interface AuditLogFilters {
  page?: number;
  limit?: number;
  userId?: string;
  action?: string;
  resource?: string;
  status?: 'SUCCESS' | 'FAILURE';
  startDate?: string;
  endDate?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  search?: string;
}

export interface AuditLog {
  id: string;
  timestamp: string;
  userId?: string;
  action: string;
  resource?: string;
  resourceId?: string;
  details?: any;
  status: 'SUCCESS' | 'FAILURE';
  errorMessage?: string;
  user?: {
    id: string;
    email: string;
    firstName?: string;
    lastName?: string;
  };
}

export interface AuditLogsResponse {
  data: AuditLog[];
  count: number;
  totalPages: number;
  currentPage: number;
}

export const useAuditLogs = (filters?: AuditLogFilters) => {
  return useQuery<AuditLogsResponse>({
    queryKey: ['audit-logs', filters],
    queryFn: () => auditService.getAuditLogs(filters),
    staleTime: 30000, // 30 seconds
    refetchInterval: 60000, // Refetch every minute for real-time updates
  });
};

export const useAuditLogTypes = () => {
  return useQuery<string[]>({
    queryKey: ['audit-log-types'],
    queryFn: () => auditService.getAuditLogTypes(),
    staleTime: 300000, // 5 minutes
  });
};

export const useAuditLogAnalytics = (filters?: {
  startDate?: string;
  endDate?: string;
  userId?: string;
}) => {
  return useQuery({
    queryKey: ['audit-log-analytics', filters],
    queryFn: () => auditService.getAuditLogAnalytics(filters),
    staleTime: 60000, // 1 minute
  });
};
